let unStarMessage = (state, { payload: { messageId } }) => {
    state.stars = state.stars.filter((message) => message.id !== messageId);
};

export default unStarMessage;
